export interface IConfigPortalCredential {
  id: number;
  purchaserId: number;
  purchaserName: string;
  purchaserKey: string;
  dataProviderTypeId: number | null;
  portalUserName: string;
  portalPassword: string | null;
  portalKey: string | null;
  isActive: boolean;
  metadata: unknown | null;
}

export class ConfigPortalCredential {
  private readonly _id: number;
  private readonly _purchaserId: number;
  private readonly _purchaserName: string;
  private readonly _purchaserKey: string;
  private readonly _dataProviderTypeId: number | null;
  private readonly _portalUserName: string;
  private readonly _portalPassword: string | null;
  private readonly _portalKey: string | null;
  private readonly _isActive: boolean;
  private readonly _metadata: unknown | null;

  constructor(props: IConfigPortalCredential) {
    this._id = props.id;
    this._purchaserId = props.purchaserId;
    this._purchaserName = props.purchaserName;
    this._purchaserKey = props.purchaserKey;
    this._dataProviderTypeId = props.dataProviderTypeId;
    this._portalUserName = props.portalUserName;
    this._portalPassword = props.portalPassword;
    this._portalKey = props.portalKey;
    this._isActive = props.isActive;
    this._metadata = props.metadata;
  }

  get id(): number {
    return this._id;
  }
  get purchaserId(): number {
    return this._purchaserId;
  }
  get purchaserName(): string {
    return this._purchaserName;
  }
  get purchaserKey(): string {
    return this._purchaserKey;
  }
  get dataProviderTypeId(): number | null {
    return this._dataProviderTypeId;
  }
  get portalUserName(): string {
    return this._portalUserName;
  }
  get portalPassword(): string | null {
    return this._portalPassword;
  }
  get portalKey(): string | null {
    return this._portalKey;
  }
  get isActive(): boolean {
    return this._isActive;
  }
  get metadata(): unknown | null {
    return this._metadata;
  }

  static from(props: IConfigPortalCredential): ConfigPortalCredential {
    return new ConfigPortalCredential(props);
  }

  static toJSON(entity: ConfigPortalCredential): IConfigPortalCredential {
    return {
      id: entity.id,
      purchaserId: entity.purchaserId,
      purchaserName: entity.purchaserName,
      purchaserKey: entity.purchaserKey,
      dataProviderTypeId: entity.dataProviderTypeId,
      portalUserName: entity.portalUserName,
      portalPassword: entity.portalPassword,
      portalKey: entity.portalKey,
      isActive: entity.isActive,
      metadata: entity.metadata,
    };
  }
}
